export const handleError = (error) => {
    error = error || new Error('Unhandled error');

    console.error(error);

    if (window.Sentry) {
        window.Sentry.captureException(error);
    }
};
